/** Dev/QA-only bag fill for Bank VQA. EXISTING item ids only — guarded by bankTestGear.test.ts. */
export const BANK_TEST_GEAR_MESSAGE = 'bank:debugGrantTestGear';
export const BANK_TEST_GEAR: ReadonlyArray<{ itemId: string; quantity: number }> = Object.freeze([
  { itemId: 'red_potion', quantity: 20 },
  { itemId: 'blue_potion', quantity: 20 },
  { itemId: 'bandage', quantity: 10 },
  { itemId: 'fire_crystal', quantity: 5 },
  { itemId: 'abyss_crystal', quantity: 2 },
  { itemId: 'bow', quantity: 1 },
  { itemId: 'composite_bow', quantity: 1 },
  { itemId: 'bastard_sword_rare', quantity: 1 },
  { itemId: 'chain_mail_vest', quantity: 1 },
  { itemId: 'boots_of_swiftness', quantity: 1 },
]);
